import {apiAction} from './helper';

export const GET_REPORT_HISTORIES = apiAction('GET_REPORT_HISTORIES');
export const DOWNLOAD_REPORT_HISTORY = apiAction('DOWNLOAD_REPORT_HISTORY');
